import Phaser from 'phaser';

export interface ControlState {
  up: boolean; down: boolean; left: boolean; right: boolean;
  enter: boolean;   // F (just pressed)
  punch: boolean;   // Space (just pressed)
}

export class Controls {
  private keys!: {
    W: Phaser.Input.Keyboard.Key; A: Phaser.Input.Keyboard.Key;
    S: Phaser.Input.Keyboard.Key; D: Phaser.Input.Keyboard.Key;
    UP: Phaser.Input.Keyboard.Key; DOWN: Phaser.Input.Keyboard.Key;
    LEFT: Phaser.Input.Keyboard.Key; RIGHT: Phaser.Input.Keyboard.Key;
    F: Phaser.Input.Keyboard.Key; SPACE: Phaser.Input.Keyboard.Key;
  };
  state: ControlState = { up: false, down: false, left: false, right: false, enter: false, punch: false };

  constructor(scene: Phaser.Scene) {
    const k = scene.input.keyboard!;
    this.keys = {
      W: k.addKey('W'), A: k.addKey('A'), S: k.addKey('S'), D: k.addKey('D'),
      UP: k.addKey('UP'), DOWN: k.addKey('DOWN'), LEFT: k.addKey('LEFT'), RIGHT: k.addKey('RIGHT'),
      F: k.addKey('F'), SPACE: k.addKey('SPACE')
    };
  }

  update() {
    const k = this.keys;
    this.state.up    = k.W.isDown || k.UP.isDown;
    this.state.down  = k.S.isDown || k.DOWN.isDown;
    this.state.left  = k.A.isDown || k.LEFT.isDown;
    this.state.right = k.D.isDown || k.RIGHT.isDown;
    this.state.enter = Phaser.Input.Keyboard.JustDown(k.F);
    this.state.punch = Phaser.Input.Keyboard.JustDown(k.SPACE);
  }
}
